import { useIsFocused, useNavigation } from '@react-navigation/native';
import ListItem from 'components/atoms/ListItem';
import ThemedLayout from "components/atoms/ThemedLayout";
import ThemedLoader from 'components/atoms/ThemedLoader';
import ThemedSafeAreaComponentTop from "components/atoms/ThemedSafeAreaTop";
import ManagementGroupedThemeList from 'components/management/molecules/ManagementGroupedThemeList';
import ManagementHeader from 'components/management/molecules/ManagementHeader';
import _ from 'lodash';
import { AppRoutes } from 'navigations/app-routes';
import React, { useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import { dataConstants } from 'services/redux/data/constants';
import { listArrow } from 'styles/list';
import Text from 'theme/Text';
import { managementRightsConstants } from 'utils/constants/management-right-constants';
import FetchCreditBundles from "utils/fetch/FetchCreditBundles";
import { useShowHamburger } from "utils/helper-device";
import HelperManagementRights from 'utils/helper-management-rights';
import HelperPrice from 'utils/helper/HelperPrice';
import useFetch from "utils/hooks/useFetch";
import i18n from "utils/i18n";
import Translate from 'utils/translate';

const ManagementCreditBundlesIndex = () => {

    const showHamburger = useShowHamburger();
	const navigation = useNavigation();
	const isFocused = useIsFocused();

	const _timeslotKinds = useSelector( state => {
		return state.data[dataConstants.TIMESLOT_KINDS];
	} );
    
	const [ search, setSearch ] = useState('')

    const { data: creditBundles, loading, refetch } = useFetch( FetchCreditBundles.fetchAll, {
		variables: {
			status: [ 'active', 'inactive' ],
		}
	} );
	
	useEffect( () => {
		if( isFocused ) {
			refetch();
		}
	}, [ isFocused ] );

	const openCreditBundle =  ( creditBundle ) => {
		navigation.navigate( AppRoutes.MANAGEMENT_CREDIT_BUNDLES_EDIT, {
			creditBundleGuid: creditBundle.guid
		} );
	}

	const createCreditBundle = () => {
		openCreditBundle( {} );
	}
	
	const renderItem = ( { item, index } ) => {
		const timeslotKind = _.find( _timeslotKinds, { guid: item?.timeslot_kind?.guid } )
		const timeslotKindTitle = Translate.field( timeslotKind, 'title' )

		const itemTitle = Translate.field( item, 'title' );
		item.title = timeslotKindTitle + ' - ' + itemTitle;

		return (
			<ListItem
				title={ item.title }
				subtitle={ HelperPrice.format( item.price ) }
                accessoryRight={ listArrow }
				onPress={ openCreditBundle.bind( this, item ) }>

				<Text appearance={'hint'}>{ i18n.t('management:generic.active.' + ( item.status === 'active' ? 'yes' : 'no' )) }</Text>
			</ListItem>
		)
	}
	
	const header = (
		<ManagementHeader
			inputs={[
				{
					placeholder: i18n.t( 'management:form.search.title'),
					onChangeText: _.debounce( setSearch, 400 )
				}
			]}
			addButton={ HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.TIMESLOTS ) ? { onPress: createCreditBundle } : null }
		/>
	);
	
	const filters = _.size( search ) > 2 ? [ {field: 'name', kind: 'contains', value: search } ] : null;

	if( loading ) {
		return (
			<ThemedLoader
					text={ i18n.t( 'loading.timeslot_groups' ) }
				/>
		)
	}
	
	return (
		<ManagementGroupedThemeList
			header={ header }
			items={ creditBundles }
			renderItem={ renderItem.bind( this ) }
			filters={ filters }
			groupByKey={ 'status' }
			groupByValues={ [
				'active',
				'inactive'
			] }
		/>
    )
}

export default ManagementCreditBundlesIndex;
